{
  "version": "1.0.0",
  "languages": [
    {
      "id": "Arabic (Egyptian)",
      "code": "ar-EG"
    },
    {
      "id": "Bengali (Bangladesh)",
      "code": "bn-BD"
    },
    {
      "id": "Dutch (Netherlands)",
      "code": "nl-NL"
    },
    {
      "id": "English (India)",
      "code": "en-IN"
    },
    {
      "id": "English (US)",
      "code": "en-US",
      "isDefault": true
    },
    {
      "id": "French (France)",
      "code": "fr-FR"
    },
    {
      "id": "German (Germany)",
      "code": "de-DE"
    },
    {
      "id": "Hindi (India)",
      "code": "hi-IN"
    },
    {
      "id": "Indonesian (Indonesia)",
      "code": "id-ID"
    },
    {
      "id": "Italian (Italy)",
      "code": "it-IT"
    },
    {
      "id": "Japanese (Japan)",
      "code": "ja-JP"
    },
    {
      "id": "Korean (Korea)",
      "code": "ko-KR"
    },
    {
      "id": "Marathi (India)",
      "code": "mr-IN"
    },
    {
      "id": "Persian (Iran)",
      "code": "fa-IR"
    },
    {
      "id": "Polish (Poland)",
      "code": "pl-PL"
    },
    {
      "id": "Portuguese (Brazil)",
      "code": "pt-BR"
    },
    {
      "id": "Romanian (Romania)",
      "code": "ro-RO"
    },
    {
      "id": "Russian (Russia)",
      "code": "ru-RU"
    },
    {
      "id": "Spanish (US)",
      "code": "es-US"
    },
    {
      "id": "Tamil (India)",
      "code": "ta-IN"
    },
    {
      "id": "Telugu (India)",
      "code": "te-IN"
    },
    {
      "id": "Thai (Thailand)",
      "code": "th-TH"
    },
    {
      "id": "Turkish (Turkey)",
      "code": "tr-TR"
    },
    {
      "id": "Ukrainian (Ukraine)",
      "code": "uk-UA"
    },
    {
      "id": "Vietnamese (Vietnam)",
      "code": "vi-VN"
    }
  ]
}